// extracted by mini-css-extract-plugin
export default {"pile":"characterSymbol_pile__bZrg-","symbol":"characterSymbol_symbol__bMrl2","romaji":"characterSymbol_romaji__q1AIk","highlight":"characterSymbol_highlight__iEdjA"};